import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-clock-confirm-dialog',
  templateUrl: './clock-confirm-dialog.component.html',
  styleUrls: ['./clock-confirm-dialog.component.scss'],
})
export class ClockConfirmDialogComponent implements OnDestroy {
  mode: 'clockIn' | 'clockOut';
  staffName: string;
  staffNo: string;
  clockIn: Date;
  durationMinutes: number;
  nfcEnabled: boolean;
  currentTime: Date = new Date();
  private clockInterval: any;
  private nfcListener: any;

  constructor(
    private dialogRef: MatDialogRef<ClockConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.mode = data.mode;
    this.staffName = data.staffName;
    this.staffNo = data.staffNo;
    this.clockIn = data.clockIn ? new Date(data.clockIn) : null;
    this.durationMinutes = data.durationMinutes || 0;
    this.nfcEnabled = data.nfcEnabled || false;

    this.clockInterval = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);

    if (this.nfcEnabled) {
      this.startNfcListening();
    }
  }

  ngOnDestroy(): void {
    if (this.clockInterval) {
      clearInterval(this.clockInterval);
    }
    this.stopNfcListening();
  }

  private startNfcListening() {
    this.nfcListener = (event: MessageEvent) => {
      const data = event.data;
      if (data.type === 'NFC_RESULT') {
        this.dialogRef.close({ confirmed: true, method: 'NFC', nfcCardId: data.uid });
      }
    };
    window.addEventListener('message', this.nfcListener);

    const reactNative = (window as any).ReactNativeWebView;
    if (reactNative) {
      reactNative.postMessage(JSON.stringify({ type: 'SCAN_NFC' }));
    }
  }

  private stopNfcListening() {
    if (this.nfcListener) {
      window.removeEventListener('message', this.nfcListener);
      this.nfcListener = null;
    }
  }

  confirm() {
    this.dialogRef.close({ confirmed: true, method: 'LIST' });
  }

  cancel() {
    this.dialogRef.close();
  }

  formatDuration(minutes: number): string {
    if (!minutes) return '0m';
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
  }
}
